import { FC, useEffect, useMemo } from 'react';
import './OrderInventory.css';
import eFormType from '../../../../main/assets/enums/eFormType';
import { useForm } from 'react-hook-form';
import GeneralInput from '../../../../main/components/generalInput/GeneralInput';
import React from 'react';
import IOrder from '../../../../main/interfaces/IOrder';
import { ApiConstants } from '../../../../main/constants/ApiConstants';
import { toast } from 'react-toastify';
import axiosInstance from '../../../../main/initializers/axios';
import IProduct from '../../../../main/interfaces/IProduct';
import GeneralSelect from '../../../../main/components/select/GeneralSelect';
import useGetEnums from '../../../../main/hooks/useGetEnums/index';
import useGetUser from '../../../../main/hooks/useGetUser';
import { getCompanyTimeZone, toDateTimeLocalByTimeZone } from '../../../../main/utils/timezone';
import { useTranslation } from 'react-i18next';
interface Props {
  tempProduct?: any;
  products?: IProduct[];
  modalType: eFormType;
  onSubmitData: () => void;
  createOrUpdate: boolean;
}

const OrderInventory: FC<Props> = (props: Props) => {
  const { tempProduct, products, modalType, createOrUpdate, onSubmitData } = props;
  const user = useGetUser();
  const companyTimeZone = getCompanyTimeZone(user);
  const allEnums = useGetEnums();
  const orderStatuses = Array.isArray(allEnums?.OrderStatus) ? allEnums.OrderStatus : [];
  const safeProducts = Array.isArray(products) ? products : [];

  const { i18n } = useTranslation();

  const initialCreatedValue = useMemo(() => {
    if (modalType === eFormType.Edit && tempProduct?.created) {
      const dt = new Date(tempProduct.created);
      if (!Number.isNaN(dt.getTime())) return toDateTimeLocalByTimeZone(dt, companyTimeZone);
      return tempProduct.created;
    }
    return toDateTimeLocalByTimeZone(new Date(), companyTimeZone);
  }, [modalType, tempProduct?.created, companyTimeZone]);

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<IOrder>({
    defaultValues: {
      id: modalType === eFormType.Edit ? tempProduct?.id : 0,
      status: modalType === eFormType.Edit ? tempProduct?.status : null,
      quantity: modalType === eFormType.Edit ? tempProduct?.quantity : '',
      productId: modalType === eFormType.Edit ? tempProduct?.productId : '',
      created: initialCreatedValue,
    },
  });

  const onSubmit = (data: any) => {
    const params = {
      Id: data.id,
      Status: Number(data.status),
      ProductId: Number(data.productId),
      Quantity: Number(data.quantity),
      Created: data.created,
      UserId: 0,
      CompanyId: 0,
    };

    axiosInstance
      .post(ApiConstants.order.update, params)
      .then((response) => {
        if (response.status === 200) {
          toast.success(i18n.t('orderDetails.createdSuccessfully'));
        } else {
          toast.error(i18n.t('orderDetails.somethingwentWrong'));
        }
      })
      .catch((error) => {
        console.error('Order submit failed:', error);
        toast.error(i18n.t('orderDetails.somethingwentWrong'));
      });
  };

  useEffect(() => {
    if (createOrUpdate) {
      try {
        handleSubmit(onSubmit)();
        onSubmitData();
      } catch (error) {
        console.error('OrderInventory submit trigger failed:', error);
      }
    }
  }, [createOrUpdate]);

  useEffect(() => {
    reset({
      id: modalType === eFormType.Edit ? tempProduct?.id : 0,
      status: modalType === eFormType.Edit ? tempProduct?.status : null,
      quantity: modalType === eFormType.Edit ? tempProduct?.quantity : '',
      productId: modalType === eFormType.Edit ? tempProduct?.productId : '',
      created: initialCreatedValue,
    });
  }, [modalType, tempProduct, initialCreatedValue, reset]);

  return (
    <div className="row">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="col-sm-12">
          <div className="form-row formRowCDR">
            <div className="form-group  col-md-6 formInputStyle">
                <GeneralSelect
                preSelectedVal={i18n.t('orderDetails.selectStatus')}
                setSelectedVal={(val) => console.log(val)}
                data={orderStatuses}
                translationTag="enum.orderStatus"
                required={true}
                errors={errors}
                control={control}
                label={i18n.t('orderDetails.orderStatus')}
                name="status"
                value="name"
              />
            </div>
            <div className="form-group col-md-6 formInputStyle">
              <GeneralInput
                required={false}
                label={i18n.t('generic.quantity')}
                name="quantity"
                type="text"
                placeholder={i18n.t('generic.quantity')}
                errors={errors}
                control={control}
              />
            </div>
          </div>
          <div className="form-row formRowCDR">
            <div className="form-group col-md-6 formInputStyle">
              <GeneralInput
                required={false}
                label={i18n.t('umb.dateTime')}
                name="created"
                type="datetime-local"
                placeholder="mm/dd/yyy"
                errors={errors}
                control={control}
              />
            </div>
            <div className="form-group col-md-6 formInputStyle">
                <GeneralSelect
                preSelectedVal={i18n.t('orderDetails.selectCategorie')}
                setSelectedVal={(val) => console.log(val)}
                data={safeProducts}
                required={true}
                errors={errors}
                control={control}
                label={i18n.t('generic.product')}
                name="productId"
                value="name"
              />
            </div>
          </div>
          <hr />
        </div>
      </form>
    </div>
  );
};

export default OrderInventory;
